import React from 'react';
import { InputNumber, InputSelect, Loading } from 'components';
// import { useGetBankInfoQuery, useGetUserProfileQuery } from 'services';
import { useGetUserProfileQuery } from 'services';
import { useState } from 'react';
import { useGetPointQRGalaxyPayQuery } from 'services/point/queries/useGetPointQRGalaxyPayQuery';
import { useGetQrBidvVAQuery } from 'services/bidvVirtualAccount';
import QRCode from 'qrcode.react';
import { InputWraper } from 'modules';

enum DepositType {
  TPBank = 'TPBank',
  BIDV = 'BIDV',
  GalaxyPay = 'GP',
}

const configTypeDeposit = [
  {
    label: 'Tiểu khoản TPBank',
    value: DepositType.TPBank,
  },
  {
    label: 'Tiểu khoản BIDV',
    value: DepositType.BIDV,
  },
  // {
  //   label: 'Galaxy Pay',
  //   value: DepositType.GalaxyPay
  // }
];

const TopUpPointsFeatures = (): JSX.Element => {
  const [typeDeposit, setTypeDeposit] = useState('');
  const [inputTextGP, setInputTextGP] = useState('0');
  const [amountDepositGP, setAmountDepositGP] = useState('0');

  const { data: dataDepositGP, isLoading: isLoadingDepositGP } =
    useGetPointQRGalaxyPayQuery({ amount: amountDepositGP?.toString() });

  // useEffect(() => {
  //   const delayInputTimeoutId = setTimeout(() => {
  //     setAmountDepositGP(inputTextGP);
  //   }, 500);
  //   return () => clearTimeout(delayInputTimeoutId);
  // }, [inputTextGP, 500]);

  const { data, isLoading } = useGetUserProfileQuery();

  const { data: dataBidvQR, isFetching: isLoadingBidvQR } = useGetQrBidvVAQuery(
    {
      endCode: data?.bidvVaPayerId || '',
      enabled: typeDeposit === DepositType.BIDV && !!data?.bidvVaPayerId,
    },
  );
  if (isLoading || !data) {
    return <Loading backdrop />;
  }

  const handleKeyDown = (event: any) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      setAmountDepositGP(inputTextGP);
    }
  };

  return (
    <div className='container-fluid topup-points'>
      <h4 className='topup-points__title'>Phương thức nạp tiền</h4>
      <div className='topup-select'>
        <InputSelect
          value={typeDeposit}
          name='paymentMethod'
          onChange={(e) => {
            setTypeDeposit(e);
            setAmountDepositGP('0');
          }}
          onTouched={() => {}}
          options={configTypeDeposit}
        />
      </div>
      {typeDeposit === DepositType.TPBank && (
        <>
          <h4 className='topup-points__subtitle'>
            Thông tin chuyển khoản TPBank
          </h4>
          <div className='topup-points__wrap'>
            {data.accountNumber ? (
              <img
                id='inlineFrameExample'
                // width="500"
                height='500'
                src={`https://img.vietqr.io/image/tpbank-${data.accountNumber}-print.jpg`}
              ></img>
            ) : (
              <div className='text-center text-danger'>
                <h4>Không có thông tin Tiểu khoản TPBank tương ứng</h4>
              </div>
            )}
          </div>
        </>
      )}
      {typeDeposit === DepositType.BIDV && (
        <>
          <h4 className='topup-points__subtitle'>
            Thông tin chuyển khoản BIDV
          </h4>
          <div className='topup-points__wrap'>
            {!data?.bidvVaPayerId ? (
              <div className='text-center text-danger'>
                <h4>Không có thông tin Tiểu khoản BIDV tương ứng</h4>
              </div>
            ) : (
              <Loading isLoading={isLoadingBidvQR}>
                {dataBidvQR && (
                  <div
                    style={{
                      border: '1px solid blue',
                      background: 'white',
                      padding: '20px',
                      marginLeft: '20px',
                      maxWidth: '400px',
                    }}
                  >
                    {!dataBidvQR?.data?.vietQRImage ? (
                      <div className='text-center text-danger'>
                        <h4>Không có mã QR BIDV</h4>
                      </div>
                    ) : (
                      <img
                        src={`data:image/png;base64,${dataBidvQR.data.vietQRImage}`}
                        alt='BIDV QR Code'
                        style={{
                          height: 'auto',
                          width: '100%',
                          maxWidth: '1024px',
                          padding: '20px',
                          border: '2px solid #32528B',
                          margin: 'auto',
                        }}
                      />
                    )}
                  </div>
                )}
                {!dataBidvQR && !isLoadingBidvQR && (
                  <div className='text-center text-danger'>
                    <h4>Không thể tạo QR BIDV</h4>
                  </div>
                )}
              </Loading>
            )}
          </div>
        </>
      )}
      {typeDeposit === DepositType.GalaxyPay && (
        <>
          <h4 className='topup-points__subtitle'>Thông tin chuyển khoản</h4>
          <div className='topup-points__input'>
            <InputWraper
              label='Nhập số tiền cần nạp'
              component={InputNumber}
              inputProps={{
                value: inputTextGP,
                name: 'amount',
                onChange: (e) => {
                  setInputTextGP(e);
                },
                onKeyDown: (e) => {
                  handleKeyDown(e);
                },
                onTouched: () => {},
              }}
            />
          </div>
          {amountDepositGP != '0' && (
            <>
              <Loading isLoading={isLoadingDepositGP}>
                {dataDepositGP && (
                  <div
                    style={{
                      border: '1px solid blue',
                      background: 'white',
                      padding: '20px',
                      marginLeft: '20px',
                      maxWidth: '400px',
                    }}
                  >
                    <QRCode
                      size={256}
                      style={{
                        height: 'auto',
                        width: '100%',
                        padding: '20px',
                        border: '2px solid #32528B',
                        margin: 'auto',
                      }}
                      value={dataDepositGP?.data?.qrInfo ?? ''}
                      imageSettings={{
                        src: '/assets/images/onetouchlogo.png',
                        width: 40,
                        height: 40,
                        excavate: true,
                      }}
                    />
                    <h4 className='topup-points__text'>
                      {dataDepositGP?.data?.bankName ?? ''}
                    </h4>
                    <h4 className='topup-points__text'>
                      Số TK: {dataDepositGP?.data?.accountNo ?? ''}
                    </h4>
                    <h4 className='topup-points__text'>
                      Tên TK: {dataDepositGP?.data?.accountName ?? ''}
                    </h4>
                  </div>
                )}
              </Loading>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default TopUpPointsFeatures;
